import React from 'react';
import { Image, Tooltip } from 'antd';
import { WhatsAppOutlined, InstagramOutlined, FacebookOutlined, GlobalOutlined } from '@ant-design/icons';
import bgImage from './../../../../img/premium.png';
import CustomCarousel from './../CustomCarousel';
import ReactPlayer from 'react-player';
import styles from './viewFull.module.scss';

const ViewFull = ({ stand }) => {

  const {
    container,
    bgimg,
    img,
    logoContainerFull,
    upBannerContainerFull,
    centerContainerFull,
    upRightContainerFull,
    lowerRightContainerFull,
    fixRightContainerFull,
    upLeftContainerFull,
    leftVideo,
    socialMediaContainer
  } = styles;
  
  return (
    <div className={container}>
      <div style={{ background: `${stand.standColor}`}}>
        <Image preview={false}
          src={bgImage}
          alt='Stand Premium'
          className={bgimg}
        />
        <div className={logoContainerFull}>
          <Image preview={false} src={stand.logos[0]} alt='logo stand' className={img}/>
        </div>
        <div className={upBannerContainerFull}>
          <CustomCarousel
            images={stand.upperBanner}
            alt='upper banner'
          />
        </div>
        <div className={centerContainerFull}>
          <ReactPlayer
            url={stand.center[0]}
            width='100%'
            height='100%'
            playing
          />
        </div>
        <div className={upRightContainerFull}>
          <CustomCarousel
            images={stand.upperRightBanner}
            alt='upper right banner'
          />
        </div>
        <div className={lowerRightContainerFull}>
          <CustomCarousel
            images={stand.lowerRightBanner}
            alt='lower right banner'
          />
        </div>
        <div className={fixRightContainerFull}>
          <CustomCarousel
            images={stand.fixedRight}
            alt='fixed right banner'
          />
        </div>
        <div className={upLeftContainerFull}>
          <CustomCarousel
            images={stand.upperLeftBanner}
            alt='upper left banner'
          />
        </div>
        <div className={leftVideo}>
          <ReactPlayer
            url={stand.leftVideo[0]}
            width='100%'
            height='100%'
            playing
          />
        </div>
        <div className={socialMediaContainer}>
          <a
            href={stand.facebookLink}
            target='_blank'
            rel='noreferrer'
          >
            <Tooltip title='Facebook' color='orange'>
              <FacebookOutlined/>
            </Tooltip>
          </a>
          <a
            href={stand.instagramLink}
            target='_blank'
            rel='noreferrer'
          >
            <Tooltip title='Instagram' color='orange'>
              <InstagramOutlined/>
            </Tooltip>
          </a>
          <a
            href='https://api.whatsapp.com/send/?phone=%2b5493816202489&text&app_absent=0'
            target='_blank'
            rel='noreferrer'
          >
            <Tooltip title='WhatsApp DS Suiza' color='orange'>
              <WhatsAppOutlined/>
            </Tooltip>
          </a>
          <a
            href={stand.webLink}
            target='_blank'
            rel='noreferrer'
          >
            <Tooltip title='Sitio web' color='orange'>
              <GlobalOutlined/>
            </Tooltip>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ViewFull;